<section class="cagr-hover-chart" [style.height]="data?.height || '100%'">
  <svg
    class="cagr-hover-chart__svg"
    [attr.viewBox]="'0 0 ' + viewBoxWidth + ' ' + viewBoxHeight"
    preserveAspectRatio="xMidYMid meet"
    role="img"
    aria-label="CAGR sales chart"
  >
    <line
      class="cagr-hover-chart__axis-line"
      [attr.x1]="axisLineX"
      [attr.y1]="plotTop"
      [attr.x2]="axisLineX"
      [attr.y2]="baselineY"
    ></line>

    <text
      class="cagr-hover-chart__axis-title"
      [attr.x]="axisTitleX"
      [attr.y]="axisTitleY"
      [attr.transform]="'rotate(-90 ' + axisTitleX + ' ' + axisTitleY + ')'"
    >
      {{ leftTitle }}
    </text>

    <line
      class="cagr-hover-chart__baseline"
      [attr.x1]="plotLeft - 72"
      [attr.y1]="baselineY"
      [attr.x2]="viewBoxWidth - plotRight + 22"
      [attr.y2]="baselineY"
    ></line>

    <g
      class="cagr-hover-chart__bar-group"
      *ngFor="let row of rows; let index = index; trackBy: trackByCategory"
    >
      <rect
        class="cagr-hover-chart__bar"
        [attr.x]="xForIndex(index) - barWidth / 2"
        [attr.y]="barTop(row.value)"
        [attr.width]="barWidth"
        [attr.height]="barHeight(row.value)"
        [attr.fill]="barColor"
      ></rect>
      <text
        *ngIf="shouldShowValueLabel(row.value)"
        class="cagr-hover-chart__value-label"
        [attr.x]="xForIndex(index)"
        [attr.y]="barTop(row.value) - 8"
      >
        {{ valueLabel(row.value) }}
      </text>
      <text
        class="cagr-hover-chart__category-label"
        [attr.x]="xForIndex(index)"
        [attr.y]="baselineY + 36"
      >
        {{ row.category }}
      </text>
    </g>

    <line
      class="cagr-hover-chart__bracket"
      [attr.x1]="firstBarCenterX"
      [attr.y1]="bracketY"
      [attr.x2]="lastBarCenterX"
      [attr.y2]="bracketY"
      [attr.stroke]="bracketColor"
    ></line>
    <line
      class="cagr-hover-chart__bracket"
      [attr.x1]="firstBarCenterX"
      [attr.y1]="bracketY"
      [attr.x2]="firstBarCenterX"
      [attr.y2]="bracketDropY"
      [attr.stroke]="bracketColor"
    ></line>
    <line
      class="cagr-hover-chart__bracket"
      [attr.x1]="lastBarCenterX"
      [attr.y1]="bracketY"
      [attr.x2]="lastBarCenterX"
      [attr.y2]="arrowStemTopY"
      [attr.stroke]="bracketColor"
    ></line>
    <polygon
      class="cagr-hover-chart__arrow"
      [attr.points]="arrowPoints()"
      [attr.fill]="bracketColor"
    ></polygon>

    <ellipse
      class="cagr-hover-chart__label-pill"
      [attr.cx]="(firstBarCenterX + lastBarCenterX) / 2"
      [attr.cy]="bracketY + 2"
      rx="92"
      ry="25"
    ></ellipse>
    <text
      class="cagr-hover-chart__cagr-label"
      [attr.x]="(firstBarCenterX + lastBarCenterX) / 2"
      [attr.y]="bracketY + 10"
    >
      {{ cagrLabel }}
    </text>
  </svg>

  <div class="cagr-hover-chart__gauge" *ngIf="showGauge">
    <span class="cagr-hover-chart__gauge-value" [ngStyle]="gaugeValueStyle">{{ gaugeValueLabel }}</span>
    <div class="cagr-hover-chart__gauge-track" [ngStyle]="gaugeTrackStyle">
      <span
        *ngFor="let segment of gaugeSegments"
        class="cagr-hover-chart__gauge-segment"
        [class.cagr-hover-chart__gauge-segment--weak]="segment.tone === 'weak'"
        [class.cagr-hover-chart__gauge-segment--fair]="segment.tone === 'fair'"
        [class.cagr-hover-chart__gauge-segment--good]="segment.tone === 'good'"
      ></span>
      <span class="cagr-hover-chart__gauge-marker" [ngStyle]="gaugeMarkerStyle"></span>
    </div>
    <div class="cagr-hover-chart__gauge-scale">
      <span
        *ngFor="let label of gaugeScaleLabels"
        class="cagr-hover-chart__gauge-scale-label"
        [class.cagr-hover-chart__gauge-scale-label--start]="label.edgeClass === 'start'"
        [class.cagr-hover-chart__gauge-scale-label--middle]="label.edgeClass === 'middle'"
        [class.cagr-hover-chart__gauge-scale-label--end]="label.edgeClass === 'end'"
        [style.left.%]="label.left"
      >
        {{ label.text }}
      </span>
    </div>
  </div>
</section>
